import {Box, Grid, ListItemIcon, ListItemText, MenuItem, MenuList, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import PowerOffIcon from '@material-ui/icons/ExitToApp';
import React, { FC, useState } from 'react';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import useSettings from 'src/hooks/useSettings';

const useStyles = makeStyles(() => ({
  listItemText: {
    fontSize: '2.5em',
  },
  listSubItemText:{
    fontSize: '2em',
  },
  iconSize: {
    fontSize: '3.1875rem',
    minWidth: '78px',
  },
  subIconSize:{
    fontSize: '3rem',
    minWidth: '78px',
  },
  iconItemText:{
    fontSize:'1.8em',
    backgroundColor:'white',
    color:'inherit'
  },
}));

interface AccessMenuProps {
  handleDisconnect: () => void;
  handleThemeChange: () => void;
  handleCompleteTime?: (value: number) => void;
  completeTime?: number;
}

const AccessMenu: FC<AccessMenuProps> = ({ handleDisconnect, handleThemeChange }) => {
  const { settings } = useSettings();
  const classes = useStyles();
  const theme = settings.theme === 'DARK' ? 'LIGHT' : 'DARK';
  const [dialogDescription, setDialogDescription] = useState<JSX.Element>(null);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [showContinue, setShowContinue] = useState<boolean>(false);
  const changeThemeText = `Change to ${theme.toLowerCase()} theme`;
  

  const handleConfirmBox = () => {
    const dialogDescription = <> <Typography variant="h5" color="textSecondary" paragraph>Are you sure you want to log out of the EXO Validator application?</Typography></>;
    setDialogDescription(dialogDescription);
    setShowContinue(true);
    setDialogOpen(true);
  };

  const handleContinue = async () => {
    handleDisconnect();
    setDialogOpen(false);
  };

  return (
    <Box>
      {/* dialog on access code form submit  */}
      <ConfirmationDialog
        title={''}
        description={dialogDescription}
        open={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        handleAgree={showContinue ? handleContinue : null}
        showCancel={true}
        buttonText={'Confirm'}
        maxWidth={'sm'}
        fullWidth={true}
        variantTitle={'h1'}
      />
      <Box>
        <MenuList>
          <MenuItem onClick={handleThemeChange}>
            <ListItemIcon>
              <Brightness4Icon className={classes.iconSize} />
            </ListItemIcon >
            <ListItemText primary={changeThemeText} classes={{ primary: classes.listItemText }} />
          </MenuItem>
        </MenuList>
        <MenuList>
          <MenuItem onClick={handleConfirmBox}>
            <ListItemIcon>
              <PowerOffIcon className={classes.iconSize} />
            </ListItemIcon >
            <ListItemText primary="Logout" classes={{ primary: classes.listItemText }} />
          </MenuItem>
        </MenuList>
      </Box>
    </Box>
  );
};

export default AccessMenu;
